import { Component, computed, input, output, Signal } from '@angular/core';
import { PaginatorComponent } from '../paginator/paginator.component';
import { TableVariant } from '../table.component';

@Component({
    selector: 'app-mobile-table',
    templateUrl: './mobile-table.component.html',
    imports: [PaginatorComponent],
    host: {
        class: 'flex flex-col gap-2 h-full overflow-hidden',
        '[style.--table-row-bg]': 'rowBg()',
        '[style.--table-row-bg-hover]': 'rowBgHover()'
    }
})
export class MobileTableComponent {
    public loading = input(false);
    public totalItems = input(0);
    public pageSize = input(10);
    public currentPage = input(1);
    public pageChange = output<number>();
    public pageSizeChange = output<number>();
    public variant = input<TableVariant>('default');

    protected rowBg: Signal<string> = computed(() =>
        this.variant() === 'contrast' ? 'var(--base-3)' : 'var(--base-2)'
    );
    protected rowBgHover: Signal<string> = computed(() => 'var(--base-4)');
}
